export function getStaticScriptUrl(brandName: string, path: string): string {
	let origin: string = window.location.origin;
	origin = origin.replace('localhost', 'integ-config');

	return `${origin}/static_cms/${brandName}/static/${path}`;
}
